import {clsx} from 'clsx'
import type React from 'react'

import styles from './Panel.module.css'

interface PanelProps {
  children: React.ReactNode
  id?: string
  className?: string | undefined
  style?: React.CSSProperties
}

export const Panel: React.FC<PanelProps> = ({children, className, ...rest}) => {
  return (
    <div className={clsx(styles.Box, className)} {...rest}>
      {children}
    </div>
  )
}
